import {createReducer, on} from '@ngrx/store';
import {firmaEntitiesStateInitial} from './firma-entities.state.initial';
import {FirmaEntitiesActions} from './firma-entities.actions';
import {firmaEntitiesAdapter} from './firma-entities.adapter';


export const firmaEntitiesReducers = createReducer(
  firmaEntitiesStateInitial,

  on(FirmaEntitiesActions.getFirma, (state, {firmenId}) => ({
    ...state,
    getLoading: state.getLoading.includes(firmenId) ? state.getLoading : [...state.getLoading, firmenId],
  })),

  on(FirmaEntitiesActions.getFirmaSuccess, (state, {firmaDto}) => (
    firmaEntitiesAdapter.upsertOne(firmaDto, {
      ...state,
      getLoading: state.getLoading.filter(id => id !== firmaDto.id),
      getLoaded: state.getLoaded.includes(firmaDto.id) ? state.getLoaded : [...state.getLoaded, firmaDto.id],
    })
  )),

  on(FirmaEntitiesActions.getFirmaFailure, (state, {firmenId}) => ({
    ...state,
    getLoading: state.getLoading.filter(id => id !== firmenId),
  }))
);
